import { Injectable } from '@angular/core';
import { BehaviorSubject } from "rxjs";
import { DmsAvailableSignaturesResponseSchema, DigitalSignaturesSchema } from '../../model/dmsAvailableSignaturesResponseSchema';

@Injectable({
  providedIn: 'root'
})
export class UserSignaturesService {
  private signaturesSubject = new BehaviorSubject<DigitalSignaturesSchema[]>([]);
  availableSignatures$ = this.signaturesSubject.asObservable();
  setAvailableSignatures$(newValue: DigitalSignaturesSchema[]) {
    this.signaturesSubject.next(newValue);
  }
  constructor() { }
}
